import debounce from "lodash.debounce";
import axios from "axios";
const { CancelToken, isCancel } = axios;

const searchMixin = {
  data() {
    return {
      debouncedFetch: null,
      debouncedEvent: null,
      loading: false,
      fetching: false,
      searching: false,
      query: null
    };
  },
  created() {
    this.initDebouncedFetch();
    this.initDebouncedEvent();
  },
  methods: {
    resetSearch() {
      if (this.url) {
        this.resetOptions();
      }
      // Clear data first (guaranteed to work)
      this.$refs.multiselect.search = null;
      this.query = null;
      this.clearSelectedValue();
      this.$emit("reset");

      // DOM manipulation last with error handling
      try {
        document.getElementsByClassName("multiselect__input")[0].blur();
        if (this.multiselect() && this.multiselect().list) {
          this.multiselect().list.scrollTop = 0;
        }
      } catch (e) {
        // Silently handle DOM access errors
        console.warn("resetSearch: DOM access failed", e);
      }
    },
    clearOptions() {
      this.internalOptions = [];
      this.showResults = false;
    },
    resetOptions() {
      if (this.hasTrending) {
        this.internalOptions = this.trending;
        this.showResults = true;
        this.searching = false;
        setTimeout(() => {
          this.$refs.multiselect.pointerSet(0);
        }, 0);
      } else {
        this.clearOptions();
      }
    },
    stopLoading() {
      this.loading = false;
      this.fetching = false;
    },
    fetch(url) {
      this.fetching = true;

      // Cancel previous requests
      if (this._token) {
        this._token.cancel();
        this._token = null;
      }

      // Prepare cancel token
      this._token = CancelToken.source();

      // Perform request
      axios
        .get(url, { cancelToken: this._token.token })
        .then(response => {
          this.internalOptions = response.data;
          this.showResults = true;
          this.debouncedEvent(response.data.length);
          this.stopLoading();
          if (this.emitNewOptions) this.$emit("new-options", response.data);
        })
        .catch(thrown => {
          if (!isCancel(thrown)) {
            this.stopLoading();
            this.$emit("fail");
          }
        });
    },
    onSearch(query) {
      this.query = query;
      if (!this.url || !query) return;

      if (query.length < this.minChars) {
        this.debouncedFetch.cancel();
        query.length === 0 ? this.resetOptions() : this.clearOptions();
        return;
      }

      this.loading = true;
      this.searching = true;
      this.debouncedFetch(query);
    },
    initDebouncedFetch() {
      this.debouncedFetch = debounce(function(query) {
        const queryUrl = this.internalUrl.replace("{query}", query);
        this.fetch(queryUrl);
      }, 500);
    },
    initDebouncedEvent() {
      this.debouncedEvent = debounce(function(resultCount) {
        let eventName = "search-result";
        if (resultCount < 1) eventName = "search-no-result";
        this.$emit(eventName, { target: { query: this.query } });
      }, 1500);
    }
  }
};

export default searchMixin;
